import React from 'react';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import WeekView from '../WeekView/WeekView';
import MonthView from '../MonthView/MonthView';
import { CalendarWrapper } from './Calendar.styled';
import { useCalendar } from '../handlers/useCalendar';
import { addSurgeryDates } from '../handlers/calendarHandlers';
import useSurgeryDatesEffect from '../hooks/useSurgeryDatesEffect';
import useMobileNavBarEffect from '../hooks/useMobileNavBarEffect';
import useVisibleDateRangeEffect from '../hooks/useVisibleDateRangeEffect';
import { CALENDAR_VIEW } from 'src/constants/appConstants';


const Calendar = () => {
    const {
        selectedDate,
        calendarView,
        visibleDateRange,
        surgeryDates,
        orderSummaryModal,
        callOrderOrCalendar,
        setComponentVisibleDateRange,
        changeSelectedDate,
    } = useCalendar();

    useSurgeryDatesEffect(surgeryDates, visibleDateRange, callOrderOrCalendar);
    useMobileNavBarEffect(calendarView, selectedDate, orderSummaryModal);
    useVisibleDateRangeEffect(calendarView, selectedDate, callOrderOrCalendar, setComponentVisibleDateRange);

    return (
        <CalendarWrapper className="calender-wrapper" calendarView={calendarView}>
            {calendarView === CALENDAR_VIEW.WEEK && (
                <div className="calendar-transition-wrapper">
                    <WeekView
                        addSurgeryDates={() => addSurgeryDates(surgeryDates, visibleDateRange)}
                        changeSelectedDate={changeSelectedDate}
                    />
                </div>
            )}
            {calendarView === CALENDAR_VIEW.MONTH && (
                <div className="calendar-transition-wrapper">
                    <MonthView changeSelectedDate={changeSelectedDate} />
                </div>
            )}
        </CalendarWrapper>
    );
};

export default Calendar;
